/**
 * One task's history, standalone (S-03).
 *
 * The same timeline the open card shows. This route exists for a link that
 * names a task binding without a card to open — an incident report, an error
 * message, a bookmark from before ADR-118.
 */

import type { ReactNode } from 'react';
import { Link, useParams } from 'react-router';

import { RunTimeline } from '../components/run-timeline.js';
import { useTasks } from '../queries.js';
import { Section } from '../components/state.js';
import { Button } from '@primer/react';

export function RunsScreen(): ReactNode {
  const { id } = useParams();
  const tasks = useTasks();

  if (id === undefined) return <p className="placeholder-inline">No task was named.</p>;

  const task = (tasks.data ?? []).find((entry) => entry.taskBindingId === id) ?? null;

  return (
    <div className="stack">
      <p>
        <Button as={Link} to={task === null ? '/board' : `/board/${task.externalItemId}`}>
          {task === null ? 'Back to the board' : 'Open the card'}
        </Button>
      </p>

      <Section label={task?.title ?? 'Task history'} lede={task === null ? id : undefined}>
        <RunTimeline taskBindingId={id} />
      </Section>
    </div>
  );
}
